import {
  OPEN_MODAL,
  CLOSE_MODAL
} from 'actions/modals'

export const initialState = {
  currentModal: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL: {
      return {
        ...state,
        currentModal: action.modalName
      }
    }
    case CLOSE_MODAL: {
      return {
        ...state,
        currentModal: state.currentModal === action.modalName ? null : state.currentModal
      }
    }
  }
  return state
}
